
define('modules/application/wizard/classes/genericElement',[
		"app",

		// Libs
		"backbone",


		//Classes
		"./UIElement"
	],

	function(app, Backbone, UIElement) {

		var genericElement = _.extend({}, UIElement, {

				Views: {
					titleBar: UIElement.Views.titleBar.extend({}),
					content: UIElement.Views.content.extend({

						serialize: function() {
							return {
								model: this.model,
								app: app
							};
						},
						toggleInfos: function(e, currentElement) {
							var that = currentElement;
							e.preventDefault();

							if (window.isBrowserCompatibleWithAnimation())
								$(e.currentTarget).find(".arrow-info").transition({
									rotate: "+=180"
								});
							else {
								if ($(e.currentTarget).parent().find(".tooltip:visible").length > 0)
									$(e.currentTarget).find(".arrow-info").attr("src", "/assets/img/info-arrow-down.png");
								else
									$(e.currentTarget).find(".arrow-info").attr("src", "/assets/img/info-arrow-up.png");
							}

							if ($(e.currentTarget).parent().find(".tooltip:visible").length === 0)
								$(e.currentTarget).parent().find("hr").toggle();

							$(e.currentTarget).parent().find(".tooltip").slideToggle(function() {
								if ($(e.currentTarget).parent().find(".tooltip:visible").length === 0) $(e.currentTarget).parent().find("hr").toggle();
							});
							return false;
						}
					}),
				},
				Model: UIElement.Model.extend({

				})
				});

			// Required, return the module for AMD compliance
			return genericElement;

		});